export class LoggedOutController {
    /* @ngInject */
    constructor($state, $stateParams) {
        this.$state = $state;
        this.$stateParams = $stateParams;
    }

    $onInit() {
        this.workerName = this.$stateParams.workerName;
    }

    goToLoginFlow() {
        let url = this.$stateParams.url;
        if (url) {
            window.location.href = url;
        } else {
            this.$state.go('flow');
        }
    }
}
